import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'richTextToPlainText'
})
export class RichTextToPlainTextPipe implements PipeTransform {

  constructor() { }


  transform(value: string): string {
    if (!value) return '';
    // Create a dummy element to convert HTML to plain text
    const tempElement = document.createElement('div');
    tempElement.innerHTML = value.toString();

    // Extract plain text from the dummy element
    const plainText = tempElement.textContent || tempElement.innerText;

    return plainText;
  }

}
